import React, { useEffect, useRef, useState } from "react";
import { baseUrl } from '../../config.js'
import { Link, Outlet, useNavigate, useParams } from 'react-router-dom';
import { MapContainer, TileLayer, Circle } from 'react-leaflet';
import Calendar from "react-calendar";
import useToken from '../../useToken';

import 'leaflet/dist/leaflet.css';
import 'react-calendar/dist/Calendar.css';
import './Almacen.css';

import Galeria from '../../img/Galeria.png';
import Cargando from '../../img/Cargando.gif';
import Cerrar from '../../img/Cerrar.png';
import Play from '../../img/Play.png';
import { Imagenes, idServiciosRC, iconoServicio, tipoAlmacen, idsRC, formatoFecha, formatoFechaTxt, formatoNumero, formatoNumeroEntero, formatoMedidasCompactas, ImagenesTransporte, Dias } from '../../almacen.js';
import descMedidas from '../../img/descMedidas.png';
import Info from '../../img/Info.png';
import RatingListModal, { StarsRow } from '../RatingComponent/RatingListModal';

const Almacen = ({user, setModalLogin})=>{
    const {token} = useToken();
    const [config, setConfig] = useState(localStorage.getItem('config') ? JSON.parse(localStorage.getItem('config')) : {
      idioma : 'es',
      sistema : 'internacional',
    })

    const { id } = useParams();
    const navigate = useNavigate();
    const [publicacion, setPublicacion] = useState({TypeTime:{}});
    const [video, setVideo] = useState({});
    const [info, showInfo] = useState(false);
        const [showRatingsModal, setShowRatingsModal] = useState(false);
        const [avgRating, setAvgRating] = useState(null);
        const [ratingsCount, setRatingsCount] = useState(0);
    const [calendario, setCalendario] = useState(false);
    const [calendarioF, setCalendarioF] = useState(false);
    const [periodo, setPeriodo] = useState("3");
    const hoy = new Date();
    const auxMax = new Date();
    const maxDate = new Date(auxMax.setFullYear(auxMax.getFullYear() + 1));
    const fi = new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()+7);
    const ff = new Date(fi.getTime());
    ff.setDate(fi.getDate()+29);
    const [fechaI, setFechaI] = useState(fi);
    const [fechaF, setFechaF] = useState(ff);
    const [fechaMinima, setFechaMinima] = useState(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
    const [dias, setDias] = useState();
    const [costo, setCosto] = useState();
    const [espacios, setEspacios] = useState(1);
    const [error, setError] = useState("");
    const [reservarFixed, setReservarFixed] = useState(false);
    const [cargando, setCargando] = useState(false);
    const refEspacios = useRef();
    const refDias = useRef();
    const divMedidas = useRef();
    const refCalendario = useRef();
    const refCalendarioF = useRef();

    useEffect(()=>{
        // console.log("cambio fechaF", fechaF)
    }, [fechaF])

    const lblsTiempo = {
        "1" : "Días",
        "2" : "Semanas",
        "3" : "Meses",
        "4" : "Años",
    }
    
    const lblsTime = {
        "1" : "Día",
        "2" : "Semana",
        "3" : "Mes",
        "4" : "Año",
    }

    useEffect(()=>{
        getData();
        // Obtener promedio de calificación y cantidad
        if (id && token) {
            fetch(baseUrl+`Post/ratings/${id}/avg`, {
                headers: { 'Authorization': `Bearer ${token}` }
            })
            .then(res => res.json())
            .then(data => {
                setAvgRating(data.avg*1 || null);
                setRatingsCount(data.count || 0);
            });
        }
        if (id) {
            let vistos = JSON.parse(localStorage.getItem('vistos') || '[]');
            vistos = vistos.filter(v => String(v) !== String(id));
            vistos.unshift(id);
            if (vistos.length > 50) vistos.pop();
            localStorage.setItem('vistos', JSON.stringify(vistos));
        }
    },[id, token])

    const handleClickOutside = (event) => {
        if (divMedidas.current && !divMedidas.current.contains(event.target)) {
            showInfo(false);
        }
        else if (refCalendario && refCalendario.current && !refCalendario.current.contains(event.target)) {
            setCalendario(false);
        }
        else if (refCalendarioF && refCalendarioF.current && !refCalendarioF.current.contains(event.target)) {
            setCalendarioF(false);
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);
    
    useEffect(()=>{
        if(fechaF && fechaI){
            let intervalo = Math.ceil((fechaF.getTime() - fechaI.getTime())/86400000)+1;
            console.log({intervalo})
            const aux = new Date(fechaI.getTime());
            if(periodo == "2"){
                intervalo = Math.round(intervalo*100/7)/100;
            }
            else if(periodo == "3"){
                intervalo = Math.round(intervalo*100/30)/100;
            }
            else if(periodo == "4"){
                intervalo = 0;
                while(fechaF >= aux){
                    intervalo++;
                    aux.setFullYear(aux.getFullYear()+1)
                }
                const diferenciaDias = Math.ceil((fechaF.getTime() - aux)/86400000)+1;
                intervalo += diferenciaDias/(fechaF.getFullYear() % 4 == 0 ? 366 : 365);
            }
            if(intervalo != 0){
                console.log(intervalo)
                setDias(intervalo)
            }
        }
    }, [fechaI, fechaF, publicacion])
    
    useEffect(()=>{
        if(fechaF && fechaI){
            let total = calculaPrecio();
            total = Math.round(total*100)/100;
            setCosto(total*espacios);
        }
    }, [dias, espacios, publicacion])

    useEffect(()=>{
        const data = localStorage.getItem('datosReserva');
        if(dias && !data)
            cambiaFechaF();
        else{
            if(data){
                const aux = JSON.parse(data);
                if(aux?.spaces)
                    setEspacios(aux?.spaces)
                if(aux?.endDate){
                    setFechaF(new Date(aux?.endDate));
                }
                if(aux?.startDate){
                    setFechaI(new Date(aux?.startDate));
                }
                setTimeout(()=>{
                    // localStorage.removeItem('datosReserva');
                }, 1000)
            }
        }
    }, [periodo])

    useEffect(()=>{
        const aux = new Date(fechaI.getTime());
        if(periodo == "2")
            aux.setDate(aux.getDate()+7);
        else if(periodo == "3"){
            aux.setDate(aux.getDate()+29);
        }
        else if(periodo == "4"){
            aux.setFullYear(aux.getFullYear()+1);
            aux.setDate(aux.getDate()-1);
        }
        setFechaMinima(aux);
    }, [periodo, fechaI])
    
    const getData = async ()=>{
        const result1 = await fetch(baseUrl+"Guest/Post/"+id, {
			method : 'get',
			headers: {
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
			return json;
		})
		.catch(error=>{
			console.error(error);
		})
        console.log(result1?.data?.TypeTime);
        if(result1?.data?.TypeTime["3"]?.active)
            setPeriodo("3");
        else{
            for(const k in result1?.data?.TypeTime){
                if(result1?.data?.TypeTime[k]?.active){
                    setPeriodo(result1?.data?.TypeTime[k]?.idTypeTime);
                }
            }
        }
        setVideo(result1?.data.Photos.find(x=>{
            return x.idCategoryPhoto == 9;
        }) || {})
        setPublicacion(result1?.data || {TypeTime:{}});

    }

    function calculaPrecio(){
        const tiempo = dias;
        const precio = publicacion?.TypeTime[periodo]?.price;
        const total = tiempo*precio;
        return total;
    }
    const reservar = () =>{
        if(!(refEspacios.current.reportValidity()
            && refDias.current.reportValidity()
        )){
            return false;
        }
        setCargando(true);
        if(espacios <= 0){
            setError("Selecciona la cantidad de espacios");
            setCargando(false);
            return false;
        }
        if(!fechaI || !fechaF){
            setError("Elige un intervalo de fechas correcto");
            setCargando(false);
            return false;
        }
        const data = {
            idPost : id,
            time: dias,
            interval: periodo,
            startDate : fechaI || '',
            endDate : fechaF || '',
            spaces : espacios || '',
            price : costo || '',
            period: periodo,
        }
        fetch(baseUrl+"Booking", {
			method: "post",
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': `Bearer ${token}`,
			},
			body: JSON.stringify(data),
		})
		.then(response=>response.json())
		.then(json=>{
			console.log(json);
            // Si el servidor rechaza (p. ej. sin tarifa para el periodo),
            // mostrar el error en lugar de navegar a /reservar/undefined
            if(!json?.id){
                setError(json?.error || 'No se pudo crear la reservación. Intentalo de nuevo.');
                setCargando(false);
                return;
            }
            navigate('/reservar/'+json.id);
		})
		.catch(error=>{
            setCargando(false);
			console.error(error);
		})
    }

    const cambiaFechaF = (e)=>{
        const valor = e ? e.target.value*1 : refDias.current.value*1;
        console.log(valor)
        if(valor === 0){
            setDias('');
            setFechaF('');
            return false;
        }
        const aux = new Date(fechaI.getTime());
        if(periodo == "1")
            aux.setDate(aux.getDate()*1 + valor - 1);
        else if(periodo == "2")
            aux.setDate(aux.getDate()*1 + valor*7 - 1);
        else if(periodo == "3"){
            aux.setDate(aux.getDate()*1 + valor*30 - 1);
        }
        else if(periodo == "4"){
            aux.setFullYear(aux.getFullYear()*1 + valor)
            aux.setDate(aux.getDate()-1);
        }
        console.log(aux)
        setFechaF(aux);
    }

    return(
        <div className={"almacen" + (!publicacion?.idPost ? " placeholder" : "")}>
            {publicacion?.status == 0 &&
                <div className="noPublicable">Está publicación se encuentra <b>sin publicar</b></div>
            }
            <h1 className="nombreAlmacen">{publicacion?.name}</h1>
            <div className="imagenesAlmacen">
                <button className="mostrarTodas" onClick={()=>{
                    navigate('fotos');
                }}>
                    <span className="icon">
                        <img src={Galeria}/>
                    </span>
                    <span>Mostrar todas las fotos</span>
                </button>
                {video?.url &&
                    <div onClick={()=>{
                        navigate('fotos/video');
                    }}>
                        <video src={video.url} muted/>
                        <div className="playButton">
                            <img src={Play}/>
                        </div>
                    </div>
                }
                {!video?.url && publicacion?.Photos && publicacion?.Photos[0] &&
                    <div onClick={()=>{
                        navigate('fotos/0');
                    }}>
                        {publicacion?.Photos[0].idCategoryPhoto == 9 &&
                            <video src={publicacion?.Photos[0].url}/>
                        }
                        {publicacion?.Photos[0].idCategoryPhoto != 9 &&
                            <img src={publicacion?.Photos[0].url}/>
                        }
                    </div>
                }
                <div>
                    {
                        publicacion?.Photos?.slice((video?.url ? 0 : 1),5)?.map((imagen, i)=>{
                            return(
                                <div key={i} onClick={()=>{
                                    navigate('fotos/'+(video?.url ? i : i+1));
                                }}>
                                    <img src={imagen.url}/>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className="datosAlmacen">
                <div>
                    {/* <h2 className="descripcionAlmacen">{publicacion?.descripcion || "Descripción del almacén"}</h2> */}
                    <h2 className="ubicacionAlmacen">{publicacion?.Town+", "+ publicacion?.State}</h2>
                    <div className="puntua" onClick={()=>setShowRatingsModal(true)}>
                        <span className="puntuacionAlmacen">
                            {avgRating ? (
                                <>
                                    {avgRating.toFixed(2)}
                                    <StarsRow value={avgRating} size={15}/>
                                </>
                            ) : '—'}
                        </span>
                        <span className="comentariosAlmacen">{ratingsCount} calificaciones</span>
                    </div>
                    {showRatingsModal && (
                        <RatingListModal idPost={id} onClose={()=>setShowRatingsModal(false)} />
                    )}
                    <div className="almacenSeccion">
                        <h3>Características del almacén</h3>
                        <div className="featureList">
                            {publicacion?.inmediate != 0 &&
                                <div className="featureCard">
                                    <span className="featureCard__icon">
                                        <img src={Imagenes["Inmediata"]} alt=""/>
                                    </span>
                                    <div className="featureCard__body">
                                        <div className="featureCard__title">Reservación Inmediata</div>
                                        <div className="featureCard__desc">Esta reservación no pasa por un proceso de aprobación por parte del Host</div>
                                    </div>
                                </div>
                            }
                            {publicacion?.officeArea &&
                                <div className="featureCard">
                                    <span className="featureCard__icon">
                                        <img src={Imagenes["Oficinas"]} alt=""/>
                                    </span>
                                    <div className="featureCard__body">
                                        <div className="featureCard__title">Área de oficinas</div>
                                        <div className="featureCard__desc">El almacén cuenta con <b>{formatoNumero(publicacion?.officeArea)} m<sup>2</sup></b> dedicados a oficinas.</div>
                                    </div>
                                </div>
                            }
                            {publicacion?.ramps !== 0 &&
                                <div className="featureCard">
                                    <span className="featureCard__icon">
                                        <img src={Imagenes["Rampa"]} alt=""/>
                                    </span>
                                    <div className="featureCard__body">
                                        <div className="featureCard__title">Andenes y Rampas de Carga y Descarga</div>
                                        <div className="featureCard__desc">El almacén cuenta con <b>{publicacion?.platforms} andenes</b> y <b>{publicacion?.ramps} rampas</b>.</div>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>

                    <div className="almacenSeccion">
                        <h3>Tipos de Almacenaje</h3>
                        <div className="featureList">
                            {publicacion?.typeOfStores?.map((tipo)=>{
                                return(
                                    <div key={tipo} className="featureCard">
                                        <span className="featureCard__icon">
                                            <img src={Imagenes[idsRC[tipo]]} alt=""/>
                                        </span>
                                        <div className="featureCard__body">
                                            <div className="featureCard__title">{tipoAlmacen[tipo].nombre}</div>
                                            <div className="featureCard__desc">{tipoAlmacen[tipo].descripcion}</div>
                                        </div>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>

                    <div className="almacenSeccion">
                        <h3>Servicios que ofrece</h3>
                        <div className="serviciosAlmacen serviciosAlmacen--vista">
                            {publicacion?.operativeServices?.map(servicio=>{
                                const icon = iconoServicio(servicio);
                                return(
                                    <div key={servicio} className="servicioVista">
                                        <span className="servicioVista__icon">
                                            {icon && <img src={icon} alt=""/>}
                                        </span>
                                        <span className="servicioVista__name">{idServiciosRC[servicio]}</span>
                                    </div>
                                )
                            })
                            }
                        </div>
                    </div>

                    {publicacion?.transport && publicacion?.transport?.length !== 0 &&
                        <div className="almacenSeccion">
                            <h3>Capacidad de carga/descarga por tipo de vehículo</h3>
                            <div className="vehiculosVista">
                                {publicacion?.transport?.map(transporte=>{
                                    const capacidad = transporte.capacity != null && transporte.capacity !== ''
                                        ? transporte.capacity
                                        : null;
                                    return(
                                        <div key={transporte.idTransport} className="vehiculoCard">
                                            <span className="vehiculoCard__icon">
                                                {ImagenesTransporte[transporte.idTransport] &&
                                                    <img src={ImagenesTransporte[transporte.idTransport]} alt=""/>
                                                }
                                            </span>
                                            <div className="vehiculoCard__body">
                                                <span className="vehiculoCard__name">{transporte.name}</span>
                                                {capacidad != null &&
                                                    <span className="vehiculoCard__cap">{capacidad}</span>
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    }

                    {publicacion?.hours && Object.keys(publicacion.hours).length !== 0 &&
                        <div className="almacenSeccion">
                            <h3>Horarios de Atención</h3>
                            <div className="horariosVista">
                                {Object.keys(publicacion.hours).map(x=>{
                                    const dia = publicacion.hours[x];
                                    if(dia.active)
                                    return(
                                        <div key={x} className="horarioRow">
                                            <span className="horarioRow__day">{Dias[x]}</span>
                                            <div className="horarioRow__slots">
                                                {dia.hours.map((slot, i)=>{
                                                    return(
                                                        <span key={i} className="horarioRow__slot">
                                                            {slot.start} – {slot.end} hrs
                                                        </span>
                                                    )
                                                })
                                                }
                                            </div>
                                        </div>
                                    )
                                })
                                }
                            </div>
                        </div>
                    }

                    {publicacion?.refund !== 0 && publicacion?.refund !== 100 &&
                        <div className="almacenSeccion">
                            <div className="politicaCard politicaCard--parcial">
                                <div className="politicaCard__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <circle cx="12" cy="12" r="9"/>
                                        <path d="M12 8v5"/>
                                        <path d="M12 16h.01"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3>Cancelación Parcial</h3>
                                    <p>Si cambias de opinión hasta 7 días antes de la fecha de inicio, recibirás un reembolso parcial.</p>
                                </div>
                            </div>
                        </div>
                    }
                    {publicacion?.refund !== 0 && publicacion?.refund === 100 &&
                        <div className="almacenSeccion">
                            <div className="politicaCard politicaCard--gratis">
                                <div className="politicaCard__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M12 3l8 3v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3z"/>
                                        <path d="M9 12l2 2 4-4"/>
                                    </svg>
                                </div>
                                <div>
                                    <h3>Cancelación gratuita</h3>
                                    <p>Si cambias de opinión hasta 7 días antes de la fecha de inicio, recibirás un reembolso total.</p>
                                </div>
                            </div>
                        </div>
                    }
                    {publicacion?.lat &&
                        <div className="almacenSeccion almacenSeccion--mapa">
                            <div className="mapaHeader">
                                <h3>Ubicación aproximada</h3>
                                <p className="mapaHeader__hint">
                                    Por privacidad, mostramos un área general
                                    {publicacion?.Town ? ` en ${publicacion.Town}, ${publicacion.State}` : ''}.
                                </p>
                            </div>
                            <div className="mapaCard mapaHuesped">
                                <MapComponent position={{ lat: publicacion.lat, lng: publicacion.lng }} />
                            </div>
                        </div>
                    }
                </div>
                <div className={"reservar"+(reservarFixed ? " fixed" : "")} data-tour="panel-reservar">
                    <div>
                        <div className="opcReservar">
                            <button className="cerrar" onClick={()=>{
                                setReservarFixed(false);
                            }}>
                                <img src={Cerrar}/>
                            </button>
                            <button className="btnCancel" onClick={()=>{
                                setFechaI(null);
                                setFechaF(null);
                            }}>
                                Borrar fechas
                            </button>
                        </div>
						<div className="descAlmacen">{formatoNumeroEntero(publicacion.assignedSpaces)} espacio{publicacion.assignedSpaces == 1 ? "" : "s"} disponibles</div>
			            <div className="descAlmacen medidas">
                            <span>{formatoMedidasCompactas(publicacion?.width, publicacion?.length, publicacion?.height, config.sistema)}</span>
                            <button className="info" onClick={()=>{
                                showInfo(true)
                            }}>
                                <img src={Info}/>
                            </button>
                            {info &&
                                <div className="descMedidas" ref={divMedidas}>
                                    <button className="cerrar" onClick={()=>{
                                        showInfo(false);
                                    }}>
                                        <img src={Cerrar}/>
                                    </button>
                                    <img src={descMedidas}/>
                                </div>
                            }
                        </div>
                        <div className="descAlmacen medidas">
                            <span>Capacidad de carga: {config.sistema == 'ingles' ? formatoNumero(publicacion?.weight*(2.20462262)/100)+'lb' : formatoNumero(publicacion?.weight/100)+'kg'}</span>
                        </div>
                        <div className="preciosInout">
                            <span>
                                <span>Precio In</span>
                                <span>${(publicacion?.priceIn*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                            </span>
                            <span>
                                <span>Precio Out</span>
                                <span>${(publicacion?.priceIn*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                            </span>
                        </div>
                        <div className="periodo" data-tour="sel-periodo">
                            {["1","2","3","4"].map(x=>{
                                if(publicacion?.TypeTime[x]?.active)
                                    return(
                                        <button className={periodo == x ? "sel" : ""} onClick={()=>{
                                            setPeriodo(x)
                                        }}>
                                            <span>${(publicacion.TypeTime[x].price*1 || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                            <span>{lblsTime[x]}</span>
                                        </button>
                                    )
                            })
                            }
                        </div>
                        {/* {periodo == "3" &&
                            <i className="nota">*Se considera un mes como 30 días naturales.</i>
                        } */}
                        <form className="resv">
                            <label className="resv-full" data-tour="input-espacios-reservar">
                                <input type="number" ref={refEspacios} min={1} value={espacios} onChange={(e)=>{
                                    setEspacios(e.target.value);
                                }} max={publicacion?.assignedSpaces}/>
                                <span>Cantidad de Espacios</span>
                            </label>
                            <label className="resv-full" data-tour="input-duracion-reservar">
                                <input
                                    type="number"
                                    ref={refDias}
                                    min={publicacion?.TypeTime[periodo]?.min || 1}
                                    max={publicacion?.TypeTime[periodo]?.max == 0 ? '' : publicacion?.TypeTime[periodo]?.max}
                                    value={dias ? Math.round(dias*1000)/1000 : ''}
                                    onChange={cambiaFechaF}
                                    step={1}/>
                                <span>{lblsTiempo[periodo] + (periodo == "3" ? '*' : '')}</span>
                                <span className="minPeriodo">Mín: {publicacion?.TypeTime[periodo]?.min || 1}</span>
                            </label>
                            <label className="resv-fecha" onClick={()=>{
                                setCalendario(true);
                                setCalendarioF(false);
                            }}>
                                <input type="text" value={formatoFecha(fechaI)} readOnly={true}/>
                                <span>Desde</span>
                            </label>
                            <label className="resv-fecha" onClick={()=>{
                                setCalendario(false);
                                setCalendarioF(true);
                            }}>
                                <input type="text" value={formatoFecha(fechaF)} readOnly={true}/>
                                <span>Hasta</span>
                            </label>

                            {calendario &&
                                <div ref={refCalendario} className="refCalendario">
                                    <h4>Desde</h4>
                                    <Calendar className="calendario"
                                        defaultActiveStartDate={fechaI} 
                                        tileClassName={({date})=>{
                                            if(date.getTime() == (new Date("2024-05-24".split("-"))).getTime()){
                                                return "highlight";
                                            }
                                        }}
                                        allowPartialRange={fechaF}
                                        value={[fechaI, fechaF]} 
                                        onChange={(value)=>{
                                            setFechaI(value[0]);
                                            if(fechaF > value[0]){
                                                setCalendario(false);
                                                return false;
                                            }
                                            else{
                                                setFechaF(value[0]);
                                            }
                                            if(value[1]){
                                                setFechaF(new Date(value[1].getFullYear(), value[1].getMonth(), value[1].getDate()));
                                                setCalendario(false);
                                            }
                                        }}
                                        selectRange={true}
                                        minDate={hoy}
                                        maxDate={maxDate}/>
                                </div>
                            }
                            {calendarioF &&
                                <div ref={refCalendarioF} className="refCalendario">
                                    <h4>Hasta</h4>
                                    <Calendar className="calendario"
                                        defaultActiveStartDate={fechaF || fechaMinima} 
                                        tileClassName={(date)=>{
                                            // console.log(date.date.getTime(), fechaI.getTime())
                                            // return date.date.getTime() == fechaI.getTime() ? "react-calendar__tile--rangeStart" : "";
                                        }}
                                        value={[fechaI, fechaF]} 
                                        tileDisabled={
                                            ({date})=>{
                                                if(date < fechaMinima){
                                                    return true;
                                                }
                                            }   
                                        }
                                        onChange={(value)=>{
                                            setFechaF(value);
                                            setCalendarioF(false);
                                        }}
                                        minDate={hoy}/>
                                </div>
                            }
                        </form>
                        <div className="divReservar">
                            <button className="btn btnReservar" data-tour="btn-reservar-almacen" onClick={()=>{
                                const data = {
                                    idPost : id,
                                    startDate : fechaI || '',
                                    endDate : fechaF || '',
                                    spaces : espacios || '',
                                    price : costo || '',
                                }
                                localStorage.setItem('datosReserva', JSON.stringify(data));
                                if(user.sub){
                                    reservar();
                                }
                                else{
                                    setModalLogin(true);
                                }
                            }}>
                                {cargando &&
                                    <img src={Cargando}/>
                                }
                                {!cargando &&
                                    <span>Reservar</span>
                                }
                            </button>
                        </div>
                        {error &&
                            <div className="error">
                                {error}
                            </div>
                        }
                        <div className="sincobro">
                            Aún no se te cobrará nada
                        </div>
                        {fechaI &&
                            <div className="intervalo">
                                <div>
                                    <span>Del</span>
                                    <span>{formatoFechaTxt(fechaI)}</span>
                                </div>
                                {fechaF &&
                                <>
                                    <div>
                                        <span>Hasta</span>
                                        <span>{formatoFechaTxt(fechaF)}</span>
                                    </div>
                                    <div className="total">
                                        <span>Total (MXN)</span>
                                        <span>${(costo || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                                    </div>
                                </>
                                }
                            </div>
                        }
                        <div className="botonesFixed">
                            <div className="total">
                                <span>Total (MXN)</span>
                                <span>${(costo || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                            </div>
                            <button className="btn" onClick={()=>{
                                setReservarFixed(false);
                            }}>Aceptar</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="fakeReservar">
                <div className="resumen" onClick={()=>{
                        setReservarFixed(true)
                    }}>
                    <div className="total">
                        <span>${(costo || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} MXN</span>
                    </div>
                    <div>{espacios} espacio{espacios == 1 ? "" : "s"}</div>
                    {fechaI && fechaF &&
                        <div className="descAlmacen">{formatoFechaTxt(fechaI)} - {formatoFechaTxt(fechaF)}</div>
                    }
                </div>
                <div className="contReservar">
                    <button className="btn btnReservar" onClick={()=>{
                        if(user.sub){
                            if(fechaI && fechaF){
                                reservar();
                            }
                            else{
                                setReservarFixed(true)
                            }
                        }
                        else{
                            setModalLogin(true);
                        }
                    }}>
                        {cargando &&
                            <img src={Cargando}/>
                        }
                        {!cargando &&
                            <span>Reservar</span>
                        }
                    </button>
                </div>
            </div>
            <Outlet context={{publicacion}}/>
        </div>
    )
}  

const MapComponent = ({ position }) => {
    const position1 = {
        lat: Math.round(position.lat * 100) / 100,
        lng: Math.round(position.lng * 100) / 100,
    };
    return (
        <MapContainer
            center={position1}
            zoom={13}
            scrollWheelZoom={false}
            style={{ height: '100%', width: '100%' }}
        >
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a>'
            />
            <Circle
                center={position1}
                radius={4000}
                pathOptions={{
                    fillColor: '#f27830',
                    fillOpacity: 0.14,
                    color: '#f27830',
                    weight: 2,
                    opacity: 0.55,
                }}
            />
        </MapContainer>
    );
};

export default Almacen;